import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Popconfirm,
  message,
  Alert,
  Radio,
  Tooltip,
} from "antd";

import { Typography } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";

import SequenceForm from "../components/Schedules/SequenceForm";
import { useParams } from "react-router-dom";
import ScheduleCalendar from "../components/ScheduleCalendar";
import ButtonLoader from "../components/ButtonLoader";
import RequirePermission from "../components/Common/RequirePermission";
const { Title } = Typography;

const Sequences = () => {
  const { id } = useParams();
  const [isSequenceModalOpen, setIsSequenceModalOpen] = useState(false);
  const [enableEditSchedule, setEnableEditSchedule] = useState(false);
  const [sequencePlaylists, setSequencePlaylists] = useState([]);
  const [events, setEvents] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [sequences, setSequences] = useState([]);
  const [schedule, setSchedule] = useState(null);
  const [editingSequence, setEditingSequence] = useState(null);
  const [selectedSequenceId, setSelectedSequenceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [createPermission, setCreatePermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    setCurrentPage(1);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleEdit = (record) => {
    setIsSequenceModalOpen(true);
    setEditingSequence(record);
  };

  const handleCreateSequence = () => {
    setIsSequenceModalOpen(true);
    setEditingSequence(null);
  };

  const handleEnableEditSchedule = () => {
    setEnableEditSchedule(true);
  };

  const handleSubmitSequenceSchedule = async () => {
    try {
      const formData = {
        events: events.map((e) => {
          return { sequence_id: e.sequenceId, scheduled_date: e.date };
        }),
      };
      console.log(formData);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/schedules/${schedule.id}/sequences/update-sequence-schedule`,
        formData
      );
      const updated_row_count = response.data.data.updated_row_count;
      message.success("Sequence schedule updated successfully");
      await fetchData();
      setSelectedSequenceId(null);
      setEnableEditSchedule(false);
    } catch (err) {
      message.error(err.message);
      console.log(err);
    }
  };
  const cancelSubmitSequenceSchedule = () => {
    setSelectedSequenceId(null);
    setEnableEditSchedule(false);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/api/schedules/${schedule.id}/sequences/${id}`
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 1) {
        message.success("Sequence deleted");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/schedules/${id}/sequences`
      );
      let records = response.data.data;
      setSchedule(records);
      const updatedSequences = records.sequences.map((sequence) => {
        const colors = generateColorFromString(
          `${sequence.name}-${sequence.id}`
        );
        return { ...sequence, ...colors };
      });
      setSequences(updatedSequences);
      setEvents(
        records.schedule_days.map((ev) => {
          const seqID = ev.sequence_id;
          const dateStr = ev.scheduled_date;
          const selectedSequence = updatedSequences.find(
            (seq) => seq.id === seqID
          );
          if (!selectedSequence) return;
          return {
            id: `${seqID}-${dateStr}`,
            title: selectedSequence.name,
            date: dateStr,
            sequenceId: seqID,
            backgroundColor: selectedSequence.backgroundColor,
            borderColor: selectedSequence.borderColor,
            textColor: selectedSequence.textColor,
          };
        })
      );
      setSequencePlaylists(records.sequence_playlists);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching sequence data", error);
    }
  };

  useEffect(() => {
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, []);

  const generateColorFromString = (str) => {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 33) ^ str.charCodeAt(i);
    }

    const hue = Math.abs(hash) % 360;
    return {
      backgroundColor: `hsl(${hue}, 60%, 85%)`,
      borderColor: `hsl(${hue}, 60%, 45%)`,
      textColor: `hsl(${hue}, 80%, 15%)`,
    };
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setCreatePermission(parseInt(permissions["signage.schedule_create"]) === 1);
    setDeletePermission(parseInt(permissions["signage.schedule_delete"]) === 1);
    setEditPermission(parseInt(permissions["signage.schedule_edit"]) === 1);
  }, []);

  const columns = [];

  columns.push({
    title: "Sequence Name",
    dataIndex: "name",
    render: (name, record) => {
      const isSelected = selectedSequenceId === record.id;

      const tooltipContent = (
        <table
          style={{ fontSize: 12, borderCollapse: "collapse", minWidth: 200 }}
        >
          <thead>
            <tr>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "4px 8px",
                  textAlign: "left",
                }}
              >
                Playlist
              </th>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "4px 8px",
                  textAlign: "left",
                }}
              >
                Start
              </th>
              <th
                style={{
                  borderBottom: "1px solid #ddd",
                  padding: "4px 8px",
                  textAlign: "left",
                }}
              >
                End
              </th>
            </tr>
          </thead>
          <tbody>
            {sequencePlaylists &&
              sequencePlaylists
                .filter((playlist) => playlist.sequence_id === record.id)
                .map((item, index) => (
                  <tr key={index}>
                    <td style={{ padding: "4px 8px" }}>{item.playlist}</td>
                    <td style={{ padding: "4px 8px" }}>{item.start}</td>
                    <td style={{ padding: "4px 8px" }}>{item.end}</td>
                  </tr>
                ))}
          </tbody>
        </table>
      );

      return (
        <div
          style={{
            backgroundColor: record.backgroundColor,
            color: record.textColor,
            padding: "8px 12px",
            borderRadius: 6,
            border: `1px solid ${record.borderColor || "#000"}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {enableEditSchedule ? (
              <Radio
                checked={isSelected}
                onChange={() => setSelectedSequenceId(record.id)}
                style={{ color: record.textColor }}
              >
                {record.name}
              </Radio>
            ) : (
              <span>{record.name}</span>
            )}
          </div>

          {
            <Tooltip title={tooltipContent} placement="top">
              <InfoCircleOutlined
                style={{
                  marginLeft: 8,
                  color: record.textColor,
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          }
        </div>
      );
    },
  });

  if (enableEditSchedule && (editPermission || deletePermission)) {
    columns.push({
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user && (
            <>
              {editPermission && (
                <>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                  />
                </>
              )}
              {deletePermission && (
                <Popconfirm
                  title="Are you sure to delete this sequence?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger size="small" icon={<DeleteOutlined />} />
                </Popconfirm>
              )}
            </>
          )}
        </Space>
      ),
    });
  }

  return (
    <RequirePermission permission="signage.schedule_view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} - Sequences`}</title>
        </Helmet>
        <Title
          level={3}
          style={{ marginBottom: "1rem", textTransform: "capitalize" }}
        >
          {`Sequence List - ${schedule?.name}`}
        </Title>
        <div className="row">
          <div className="col-md-4 mb-3">
            <div className="d-flex justify-content-between mb-3">
              {!enableEditSchedule && editPermission && (
                <Button type="primary" onClick={handleEnableEditSchedule}>
                  Edit Schedule
                </Button>
              )}

              {enableEditSchedule && createPermission && (
                <Button type="primary" onClick={handleCreateSequence}>
                  Add New Sequence
                </Button>
              )}
            </div>
            <Table
              loading={loading}
              columns={columns}
              dataSource={sequences}
              scroll={{ x: "max-content" }}
              rowKey={(record) => record.id}
              onChange={handleTableChange}
              pagination={false}
            />
          </div>
          <div className="col-md-8 mb-3">
            <div className="col-sm-12 mb-3">
              <Alert
                message="During unallocated time, assigned playlist will be played"
                type="info"
                closeIcon={false}
              />
            </div>
            <ScheduleCalendar
              enableEdit={enableEditSchedule}
              sequences={sequences}
              selectedSequenceId={selectedSequenceId}
              events={events}
              setEvents={setEvents}
            />
          </div>
          {enableEditSchedule && editPermission && (
            <div className="col-12 mb-3 d-flex justify-content-between">
              <Button
                type="default"
                htmlType="button"
                onClick={cancelSubmitSequenceSchedule}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="button"
                onClick={handleSubmitSequenceSchedule}
                disabled={submitting}
              >
                {!submitting ? (
                  "Save Schedule"
                ) : (
                  <ButtonLoader text="Submitting..." />
                )}
              </Button>
            </div>
          )}
        </div>

        {isSequenceModalOpen && (
          <SequenceForm
            scheduleId={id}
            isSequenceModalOpen={isSequenceModalOpen}
            closeModal={() => setIsSequenceModalOpen(false)}
            editingSequence={editingSequence}
            handleUpdateList={() => fetchData()}
          />
        )}
      </div>
    </RequirePermission>
  );
};

export default Sequences;
